<ng-container *ngrxLet="isAuthenticated$ as isAuthenticated">
  <lui-layout-main>
    <lui-navbar>
      <a [routerLink]="['/']" luiNavbarLogo>
        <lui-logo></lui-logo>
      </a>
      <div luiNavbarEnd>
        <div class="hstack gap-1" *ngIf="isAuthenticated" data-test="nav-menu">
          <button
            luiIconButton
            hoverShape="square"
            [matMenuTriggerFor]="menu"
            data-test="user-menu"
          >
            <mat-icon svgIcon="avatar" title="Profile" i18n-title></mat-icon>
            <mat-menu #menu xPosition="before">
              <ng-container *ngFor="let item of userMenu$ | async">
                <ng-container [ngSwitch]="item.type">
                  <ng-container *ngSwitchCase="'route'">
                    <button
                      [attr.data-test]="item.id"
                      *ngIf="rlaGuards.isRoute(item)"
                      [routerLink]="item.route"
                      mat-menu-item
                    >
                      {{ item.label }}
                    </button>
                  </ng-container>
                  <ng-container *ngSwitchCase="'link'">
                    <a
                      [attr.data-test]="item.id"
                      *ngIf="rlaGuards.isLink(item)"
                      mat-menu-item
                      [href]="item.href"
                      [target]="item.target || '_blank'"
                    >
                      {{ item.label }}
                    </a>
                  </ng-container>
                  <ng-container *ngSwitchCase="'action'">
                    <button
                      data-test="logout"
                      class="menu-item"
                      [class.border-top]="item.label === 'Logout'"
                      *ngIf="rlaGuards.isAction(item)"
                      mat-menu-item
                      (click)="item.cb()"
                    >
                      <mat-icon
                        *ngIf="item.icon"
                        [svgIcon]="item.icon"
                      ></mat-icon>
                      {{ item.label }}
                    </button>
                  </ng-container>
                </ng-container>
              </ng-container>
            </mat-menu>
          </button>
          <button
            data-test="main-menu"
            luiMenuButton
            (toggle)="mainMenu.toggle()"
            [open]="mainMenu.opened"
          ></button>
        </div>
      </div>
    </lui-navbar>
    <router-outlet></router-outlet>

    <ng-container
      *ngrxLet="{
        portal: bottomBarService.portal$,
        state: bottomBarService.state$
      } as data"
    >
      <div
        [@bottomBar]="!data.portal ? 'hidden' : data.state"
        class="bottom-bar bottom-0 z-2 overflow-hidden w-100"
        [ngClass]="{
          'position-sticky': bottomBarService.config.position === 'sticky',
          'position-fixed': bottomBarService.config.position === 'fixed'
        }"
        data-test="bottom-bar"
        [attr.data-test-state]="data.state"
      >
        <ng-container *ngIf="data.portal">
          <ng-template [cdkPortalOutlet]="data.portal"></ng-template>
        </ng-container>
      </div>
    </ng-container>

    <lui-footer-main [links]="footerLinks$ | async" [copyright]="copyright">
      <div luiFooterMainTerms i18n>
        This website is operated by Lockton Companies LLP, a limited liability
        partnership registered in England & Wales at the St Botolph Building,
        138 Houndsditch, London EC3A 7AG under registration number OC353198.
        Lockton Companies LLP is authorised and regulated by the Financial
        Conduct Authority, firm reference number 523069.
      </div>
    </lui-footer-main>
  </lui-layout-main>
  <lui-main-menu #mainMenu [links]="menuLinks$ | async"></lui-main-menu>
</ng-container>

<lui-loading-overlay
  *ngIf="loading$ | async"
  class="loading-overlay"
  data-test="loading-overlay"
></lui-loading-overlay>
